module.exports = __webpack_public_path__ + "static/media/kr.8f11b475.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/kr.svg
// module id = 2134
// module chunks = 0